import React from 'react';

const Header = ({ title }: { title: string }) => {
  return <h1 className="text-xl my-0 mb-7">{title}</h1>;
};

export default Header;
